import { createProvideInject } from '@collector/shared-ui'

import { IncidentsRequirePointingPositionConfig } from '../configuration/incidentsRequirePointingPositionConfig'

export const [
  provideIncidentsRequirePointingPositionConfig,
  injectIncidentsRequirePointingPositionConfig,
] = createProvideInject<IncidentsRequirePointingPositionConfig>(
  'incidentsRequirePointingPositionConfig',
)
